import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

/**
 * 1. 그래프용 매출 통계 데이터 조회
 * @param param
 * @param param.searchDateType 1week | 1month | 3month | custom
 * @param param.startDate YYYYMMDDhhmmss
 * @param param.endDate YYYYMMDDhhmmss
 * @param param.partnersId partners_users -> 0: 당영몰 전체 | 1: 인플루언서 전체 | 3, 7, 1530 etc.
 * @param param.userId user.id - 724 ? 1
 * @returns {Promise<never>}
 * salesStatistics
 * -> date, total_sales_amount, total_purchase_num, unit_price_avg
 * totalSummary
 */
const readSalesDataGraph = async (param) => {
  const { data } = await axios.get(`${baseUrl}/admin/statistics/sales`, {
    params: param,
  });
  return data;
};

/**
 * 2. 상품별 매출 상세내역 조회
 * @param param
 * @param param.offset
 * @param param.pageSize
 * @param param.startDate YYYYMMDDhhmmss
 * @param param.endDate YYYYMMDDhhmmss
 * @param param.orderType total_sales_amount | total_purchases_num | unit_price_avg (매출금액, 판매수량, 객단가)
 * @param param.orderBy desc | asc
 * @param param.partnersId partners_users -> 0: 당영몰 전체 | 1: 인플루언서 전체 | 3, 7, 1530 etc.
 * @param param.userId user.id - 724 ? 1
 * @returns {Promise<never>}
 * totalCnt
 * salesProductList
 * -> product_id, brand_name, product_name, option_id, option_name, is_cooperate, total_sales_amount, total_purchases_num, unit_price_avg
 */
const readSalesDataProduct = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/admin/statistics/sales/product`,
    {
      params: param,
    },
  );
  return data;
};

/**
 * 당영몰/드럭스토어 유입분석 조회
 * @param param
 * @param param.searchDateType 1week | 1month | 3month | custom
 * @param param.startDate YYYYMMDDhhmmss
 * @param param.endDate YYYYMMDDhhmmss
 * @param param.partnersId partners_users -> 0: 당영몰 전체 | 1: 인플루언서 전체 | 3, 7, 1530 etc.
 * @param param.userId user.id - 724 ? 1
 * @returns {Promise<never>}
 * totalSummary - total_visitor_num | new_user_num | old_user_num | totalCnt
 * userStatistics
 * -> date, total_visitor_num, new_user_num, old_user_num, totalCnt
 */
const readInflowDataGraph = async (param) => {
  const { data } = await axios.get(`${baseUrl}/admin/statistics/user`, {
    params: param,
  });
  return data;
};

const statisticsApi = {
  readSalesDataGraph,
  readSalesDataProduct,
  readInflowDataGraph,
};

export default statisticsApi;
